module.exports = __webpack_public_path__ + "cc9c93a07f692316e05e930cebeec091.ttf";